var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgnithoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 32,
    viewBox: "0 0 102 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ignitho-logo",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3223",
    "data-name": "Rectangle 3223",
    width: 4.146,
    height: 22.15,
    transform: "translate(0 0.109)",
    fill: "#3b293f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13141",
    "data-name": "Path 13141",
    d: "M173.156,267,176,269.153l-1.741,2.214a6.641,6.641,0,0,1,1.646,4.621c0,1.929-.728,4.651-3.291,5.82a5.261,5.261,0,0,1,3.228,5.158c0,4.3-3.291,6.962-7.816,6.962s-7.914-2.755-7.914-6.968h3.83c0,2.026,1.866,3.358,4.082,3.358s3.957-1.2,3.957-3.358-2.024-3.132-3.957-3.132c-4.876,0-7.914-2.974-7.914-7.847a7.611,7.611,0,0,1,7.914-7.913,6.214,6.214,0,0,1,3.575.886Zm-9.21,8.988a4.075,4.075,0,1,0,8.133,0,4.079,4.079,0,1,0-8.133,0",
    transform: "translate(-153.125 -261.919)",
    fill: "#3b293f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13142",
    "data-name": "Path 13142",
    d: "M269.063,289.961V281.8c0-2.373-1.3-4.175-3.766-4.175a4.1,4.1,0,0,0-3.989,4.366v7.974H257.48V274.33h3.455l.254,2.12a7.048,7.048,0,0,1,5.125-2.341c3.674,0,6.614,2.752,6.614,7.658v8.2Z",
    transform: "translate(-232.322 -267.702)",
    fill: "#3b293f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13143",
    "data-name": "Path 13143",
    d: "M360.756,242.064a2.278,2.278,0,0,1-4.556,0,2.278,2.278,0,0,1,4.556,0",
    transform: "translate(-312.623 -239.8)",
    fill: "#815382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13144",
    "data-name": "Path 13144",
    d: "M468.95,240.35v8.671a5.761,5.761,0,0,1,4.875-2.341c4.431,0,6.392,3.006,6.392,7.6V262.5h-3.86v-8.2c0-2.849-1.492-4.052-3.545-4.052a4,4,0,0,0-3.862,4.272V262.5h-3.86V240.35Z",
    transform: "translate(-401.197 -240.241)",
    fill: "#3b293f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13145",
    "data-name": "Path 13145",
    d: "M575.974,281.9a8.117,8.117,0,1,1-8.165-8.132,7.887,7.887,0,0,1,8.165,8.132m-12.374,0c0,2.373,1.424,4.587,4.24,4.587s4.24-2.214,4.24-4.587a4.405,4.405,0,0,0-4.24-4.619c-2.785,0-4.24,2.278-4.24,4.619",
    transform: "translate(-478.187 -267.424)",
    fill: "#3b293f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3224",
    "data-name": "Rectangle 3224",
    width: 3.86,
    height: 15.664,
    transform: "translate(43.924 6.596)",
    fill: "#3b293f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13146",
    "data-name": "Path 13146",
    d: "M397.089,251.89v4.429h4.3v3.324h-4.336v6.737a1.936,1.936,0,0,0,2.026,2.216,4.4,4.4,0,0,0,1.866-.475l1.077,3.291a8.65,8.65,0,0,1-3.2.664c-3.386.127-5.6-1.8-5.6-5.7v-6.739H390.32v-3.324h2.91V252.3Z",
    transform: "translate(-340.377 -249.628)",
    fill: "#3b293f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13147",
    "data-name": "Path 13147",
    d: "M630.183,246.7H628.92v-.459h3.049v.459h-1.263v3.227h-.522Z",
    transform: "translate(-534.459 -245.032)",
    fill: "#3b293f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13148",
    "data-name": "Path 13148",
    d: "M651.717,249.927v-2.685l-1.332,2.239h-.242l-1.343-2.222v2.67h-.506V246.24h.433l1.538,2.592,1.521-2.592h.431v3.687Z",
    transform: "translate(-550.216 -245.032)",
    fill: "#3b293f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnithoLogo);
export default __webpack_public_path__ + "static/media/ignitho-logo.6f036d3e99f7c7ac564aefbaeef684a7.svg";
export { ForwardRef as ReactComponent };